import { ReactNode } from 'react';

import { Box, Flex, FlexProps, StyleProps } from '@chakra-ui/react';

import { ContentContainer, ContentContainerProps } from '~/components/container';

export type HeroLayoutProps = {
  textContentSlot: ReactNode;
  backgroundImageSlot?: ReactNode;
  backgroundImageOverlayGradient?: StyleProps['bgGradient'] | null;
  ctaSlot: ReactNode;
  minHeight?: StyleProps['minHeight'];
  textAndCtaContainerProps?: StyleProps;
  rightContentSlot?: ReactNode;
  contentContainerProps?: ContentContainerProps;
  ctaContainerProps?: StyleProps;
} & FlexProps;

export function HeroLayout({
  textContentSlot,
  backgroundImageSlot = null,
  backgroundImageOverlayGradient = {
    '2xl':
      'radial(circle at left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0) 70%, rgb(10, 1, 15) 92%)',
  },
  ctaSlot,
  textAndCtaContainerProps,
  contentContainerProps,
  rightContentSlot = null,
  ctaContainerProps,
  ...rest
}: HeroLayoutProps) {
  return (
    <Flex
      as='section'
      bgColor='grey.900'
      overflow='hidden'
      position='relative'
      minHeight={{
        md: '572px',
      }}
      {...rest}
    >
      {!!backgroundImageSlot && (
        <Box
          inset={0}
          margin='0 auto'
          maxWidth='1440px'
          overflow='hidden'
          pointerEvents='none'
          position='absolute'
          _after={
            backgroundImageOverlayGradient
              ? {
                  content: '""',
                  bgGradient: backgroundImageOverlayGradient,
                  position: 'absolute',
                  inset: 0,
                }
              : undefined
          }
        >
          {backgroundImageSlot}
        </Box>
      )}
      <ContentContainer
        alignItems='center'
        contentMaxWidth='content-max-width-xl'
        display='flex'
        position='relative'
        padding={{
          base: '81px 16px 16px',
          md: 4,
        }}
        {...contentContainerProps}
      >
        <Flex flexDirection='column' gap='48px' width='100%' {...textAndCtaContainerProps}>
          {/* Text Content */}
          {textContentSlot}

          {/* Action Buttons */}
          <Flex
            width='100%'
            flexDirection={{
              base: 'column',
              md: 'row',
            }}
            gap={{
              base: 4,
              md: 6,
            }}
            {...ctaContainerProps}
          >
            {ctaSlot}
          </Flex>
        </Flex>
        {rightContentSlot}
      </ContentContainer>
    </Flex>
  );
}
